import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	selectEducationalAll({ commit }, params) {
		return new Promise((resolve, reject) => {
			let orderList = axios.post(`educational/selectEducationalAll`, params)
			let orgTree = axios.get('/org/findOrgTreeByCurrentUser')
			Promise.all([orderList, orgTree]).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	selectPostId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`educational/selectPostId`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	selectPostIdAll({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`educational/selectPostIdAll`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	updateServiceSteps({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`educational/updateServiceSteps`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	studentDelete({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`student/studentDelete`, { params }).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	intDictionary({ commit }, params) {
		return new Promise((resolve, reject) => {
			let getGaokaoYear = axios.get("/dictionary/findAllItemByTypeCode", { params: { typeCode: "gaokaoYear" } })
			Promise.all([getGaokaoYear]).then(res => {
				resolve(res)
			}).catch(error => {
				console.log(error)
			})
		})
	},
}